import { Injectable, inject } from '@angular/core';
import { AuthService } from '@parashift/shared/services';

@Injectable()
export class ApplicationInitService {
  private authService = inject(AuthService);

  handleAuthentication() {
    return this.authService.handleAuthentication();
  }
}
